import React from "react";
import { Toaster, Toast } from "react-hot-toast";
import PausableToastBar from "./PausableToastBar";
import Icon from "../Icon/Icon"; // 1. Import your Icon component

/**
 * A simple wrapper component for react-hot-toast's Toaster.
 * It disables the library's internal timer and uses a custom PausableToastBar
 * to handle individual, pausable dismissal timers via CSS animations.
 */
const GlobalToaster: React.FC = () => {
  return (
    <Toaster
      position="bottom-left"
      containerClassName="app-toaster-container"
      toastOptions={{
        duration: 3000, // Default duration (in ms) for toasts

        // Base class for all toasts
        className: "app-toast",

        // Add options for 'blank' toasts, which we'll use for 'info'
        blank: {
          // 2. Replace the <i> tag with the Icon component
          icon: <Icon iconName="info-outlined" />,
        },
        // Icon theming for built-in types
        success: {
          iconTheme: {
            primary: "var(--color-success)",
            secondary: "var(--color-background)",
          },
        },
        error: {
          iconTheme: {
            primary: "var(--color-danger)",
            secondary: "var(--color-background)",
          },
        },
      }}
    >
      {(t: Toast) => <PausableToastBar t={t} />}
    </Toaster>
  );
};

export default GlobalToaster;
